import React, { } from 'react';
import HeadingBuilder from './HeadingBuilder';
import * as Constants from '../constants';

export const RadioButton = ({ label, tippyAlert, tippyInfo, isChecked,
                              labelIsOnLeft = false,
                              onChange,
                            }) => {

  const radioButtonLabel =
    <HeadingBuilder
      headingText    = {label}
      tippyAlertText = {tippyAlert}
      tippyText      = {Constants.DOT}
      tippyInfoText  = {tippyInfo}
    />

  return (
    <div>
      <label className='container-left'>
        {
          labelIsOnLeft
            ? <>
                {radioButtonLabel}
                &nbsp;
              </>
            : null
        }

        <input
          type="radio"
          checked={isChecked}
          onChange={onChange}
        />

        {
          labelIsOnLeft
            ? null
            : <>
                &nbsp;
                {radioButtonLabel}
              </>
        }
      </label>
    </div>
  );
};

export default RadioButton;